<template>

  <div class="tableContainer">

    <table
      v-if="hasData"
      class="auditTable"
    >
      <thead>
        <tr>
          <th>Registro</th>
          <th>Secuencia</th>
          <th>ColumnName</th>
          <th>ValorAnterior</th>
          <th>ValorAccion</th>
          <th>Accion</th>
          <th>Fecha</th>
          <th>Terminal</th>
          <th>Usuario</th>
          <th>ObjectName</th>
        </tr>
      </thead>

      <tbody>

        <tr
          v-for="(order,index) in OrderDataObject"
          :key="index"
        >
          <td>{{ order.registro }}</td>
          <td>{{ order.secuencia }}</td>
          <td>{{ order.columnName }}</td>
          <td>{{ order.valorAnterior }}</td>
          <td>{{ order.valorAccion }}</td>
          <td>{{ order.accion }}</td>
          <td>{{ order.fecha }}</td>
          <td>{{ order.terminal }}</td>
          <td>{{ order.usuario }}</td>
          <td>{{ order.objectName }}</td>
        </tr>

      </tbody>
    </table>

    <p v-else-if="isEmpty">
      No hay información
    </p>

  </div>

</template>
<script>
    export default{
        props:{
            OrderDataObject: Array,
        },
        data(){
            return{
                
            }
        },
        computed: {
            orderDataObject: {
                get() {
                    return this.OrderDataObject;
                },
            },
    },
        methods:{
            
        }
    }

</script>